import { createContext, useContext, useEffect, useState } from "react";
import portalApi from "@/lib/portalApi";

const PortalContext = createContext(null);

export function PortalProvider({ children }) {
  const [karyawan, setKaryawan] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = async () => {
    try {
      const { data } = await portalApi.get("/karyawan-auth/me");
      setKaryawan(data);
    } catch {
      setKaryawan(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    check();
  }, []);

  const login = async (nik, pin) => {
    const { data } = await portalApi.post("/karyawan-auth/login", { nik, pin });
    if (data.access_token) localStorage.setItem("karyawan_token", data.access_token);
    setKaryawan(data);
    return data;
  };

  const logout = async () => {
    try { await portalApi.post("/karyawan-auth/logout"); } catch {}
    localStorage.removeItem("karyawan_token");
    setKaryawan(null);
  };

  const markPinChanged = () => {
    if (karyawan) setKaryawan({ ...karyawan, pin_default: false });
  };

  return (
    <PortalContext.Provider value={{ karyawan, loading, login, logout, refresh: check, markPinChanged }}>
      {children}
    </PortalContext.Provider>
  );
}

export const usePortal = () => useContext(PortalContext);
